// extracted by mini-css-extract-plugin
export default {"loader":"loading_page_loader__gLOIq","spin":"loading_page_spin__tw5Ex"};